<template>
	<div class="content" v-if="page && page.team">
		<div class="flex-center">
			<div class="image is-192x192" v-if="page.team.avatar_url">
				<img class="is-rounded" :src="page.team.avatar_url" />
			</div>
		</div>

		<h3 class="has-text-centered">{{ page.team.name }}</h3>

		<div class="level">
			<div class="level-item">{{ page.team.record }}</div>
			<div class="level-item" v-if="page.team.division_record">div. {{ page.team.division_record }}</div>
			<div class="level-item">{{ page.team.rank_standing }} Place</div>
		</div>

		<table class="table is-fullwidth">
			<tbody>
				<tr>
					<th>Points For</th>
					<td class="has-text-right">{{ page.team.points_for }}</td>
					<td class="has-text-right">{{ page.team.rank_points_for }}</td>
				</tr>
				<tr>
					<th>Points Against</th>
					<td class="has-text-right">{{ page.team.points_against }}</td>
					<td class="has-text-right">{{ page.team.rank_points_against }}</td>
				</tr>
				<tr>
					<th>Power Rating</th>
					<td class="has-text-right">{{ page.team.power_rating }}</td>
					<td class="has-text-right">{{ page.team.rank_power_rating }}</td>
				</tr>
				<tr>
					<th>Lineup Acc.</th>
					<td class="has-text-right">{{ page.team.lineup_accuracy }}</td>
					<td class="has-text-right">{{ page.team.rank_lineup_accuracy }}</td>
				</tr>
				<tr>
					<th>Luck</th>
					<td class="has-text-right">{{ page.team.luck }}</td>
					<td class="has-text-right">{{ page.team.rank_luck }}</td>
				</tr>
				<tr>
					<th>SOS</th>
					<td class="has-text-right">{{ page.team.strength_of_schedule }}</td>
					<td class="has-text-right">{{ page.team.rank_strength_of_schedule }}</td>
				</tr>
				<tr v-if="page.team.all_record">
					<th>All-Play Record</th>
					<td class="has-text-right">{{ page.team.all_record }}</td>
					<td class="has-text-right">{{ page.team.rank_all_record }}</td>
				</tr>
				<tr v-if="page.team.median_record">
					<th>Median-Play Record</th>
					<td class="has-text-right">{{ page.team.median_record }}</td>
					<td class="has-text-right">{{ page.team.rank_median_record }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ["page"],
}
</script>

<style scoped></style>
